import React from 'react';
import axios from 'axios';
import InfiniteScroll from 'react-infinite-scroll-component';
import ReactDOM from 'react-dom';
import './index.css'; 

let photoId = 0
let delay = 1000 * 10; // 10 seconds each photo
setInterval(function() {
    window.location.hash = "#" + photoId;
    photoId++;
}, delay);

const UnsplashImage = ({ url, key, id }) => (
  <div className="image-item" key={key} id={id}>
    <img src={url} alt="ninth!"/>
  </div>
);

let Collage = () => {
  const [images, setImages] = React.useState([]);
  const [loaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    fetchImages();
  }, []);

  const fetchImages = (count = 10) => {
    const apiRoot = "https://api.unsplash.com";
    const accessKey =
      "SFIrkba9uSEltEg-2XYr5v8QM4GkKdlEynLaQ1SLquA";

    axios
      .get(`${apiRoot}/photos/random?client_id=${accessKey}&count=${count}&orientation=landscape`)
      .then(res => {
        setImages([...images, ...res.data]);
        setIsLoaded(true);
      }).catch(error => {
        console.log(error);
        photoId = 0;
      });
  };

  return (
    <div className="hero is-fullheight is-bold is-info">
      <div className="hero-body">
        <div className="container">

          <InfiniteScroll
            dataLength={images}
            next={() => fetchImages(5)}
            hasMore={true}
            loader={
              <img
                src="https://9th-studio.github.io/assets/img/logo.png"
                alt="loading"
              />
            }
          >
            <div className="image-grid">
              {loaded
                ? images.map((image, index) => (
                    <UnsplashImage
                      url={image.urls.regular}
                      key={index}
                      id={index}
                    />
                  ))
                : ""}
            </div>
          </InfiniteScroll>
        </div>
      </div>
    </div>
  );
};

ReactDOM.render(<Collage />, document.getElementById("root"));
